//
// Site Header
// --------------------------------------------------
// Functionality for mobile navigation toggling

window.addEventListener('load', event => {
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');

    // Keeps offcanvas nav hidden for 500ms on page load to mask transitions
    setTimeout(function() {
        offCanvasMenuMobile.removeAttribute('style');
    }, 500);
});

window.addEventListener('load', () => {

    // Dropdown Test
    const siteHeader = document.getElementById('siteHeader')
    const offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    const offCanvasMenuDesktop = document.getElementById('offCanvasMenuDesktop');
    const menuToggleMobile = document.getElementById('menuToggleMobile');
    const menuToggleDesktop = document.getElementById('menuToggleDesktop');
    const navBackdropMobile = document.getElementById('navBackdropMobile');
    let scrollLimit = 300;
    let navOpenScrollPosY = window.scrollY;
    const tickerContainer = document.querySelector('[data-ticker-container]')

    // ids for below are retrieved from animated-hamburger-mobile.svg & animated-hamburger-desktop.svg
    const hamburgerMobile = document.getElementById('ek0RzW3Va4r1');
    const hamburgerDesktop = document.getElementById('ezVJ7TcsQZN1');
    // https://www.svgator.com/help/getting-started/svgator-player-js-api
    // ^ related to below svgatorPlayer controls
    const hamburgerMobilePlayer = hamburgerMobile ? hamburgerMobile.svgatorPlayer : {};
    const hamburgerDesktopPlayer = hamburgerDesktop ? hamburgerDesktop.svgatorPlayer : {};

    if (offCanvasMenuMobile && menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // updates navOpenScrollPos on nav open so scroll limit can compare with the current open position
            navOpenScrollPosY = window.scrollY;

            if (siteHeader.dataset.mobileOpen === 'false') {
                siteHeader.dataset.mobileOpen = 'true';
                navBackdropMobile.dataset.open = 'true';
            } else {
                siteHeader.dataset.mobileOpen = 'false';
                navBackdropMobile.dataset.open = 'false';
            }

            if (hamburgerMobile) {
                if (hamburgerMobilePlayer.play) {
                    if (hamburgerMobilePlayer.hasEnded || hamburgerMobilePlayer.isPlaying) {
                        hamburgerMobilePlayer.reverse();
                    } else {
                        hamburgerMobilePlayer.play();
                    }
                }
            }

            scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
            startListening();
        });
    }

    if (offCanvasMenuDesktop && menuToggleDesktop) {
        menuToggleDesktop.addEventListener('click', () => {
            // updates navOpenScrollPos on nav open so scroll limit can compare with the current open position
            navOpenScrollPosY = window.scrollY;

            if (siteHeader.dataset.desktopOpen === 'false') {
                siteHeader.dataset.desktopOpen = 'true';
                tickerContainer?.classList.add('sticky-ticker-desktop-dropdown-open');
            } else {
                siteHeader.dataset.desktopOpen = 'false';
                tickerContainer?.classList.remove('sticky-ticker-desktop-dropdown-open');
            }

            if (hamburgerDesktop) {
                if (hamburgerDesktopPlayer.play) {
                    if (hamburgerDesktopPlayer.hasEnded || hamburgerDesktopPlayer.isPlaying) {
                        hamburgerDesktopPlayer.reverse();
                    } else {
                        hamburgerDesktopPlayer.play();
                    }
                }
            }

            startListening();
        });
    }

    function closeMobileNav() {
        if (siteHeader.dataset.mobileOpen === 'true') {
            siteHeader.dataset.mobileOpen = 'false';
            navBackdropMobile.dataset.open = 'false';

            if (hamburgerMobile) {
                if (hamburgerMobilePlayer.play) {
                    hamburgerMobilePlayer.reverse();
                }
            }
        }
    }

    function closeDesktopNav() {
        if (siteHeader.dataset.desktopOpen === 'true') {
            siteHeader.dataset.desktopOpen = 'false';

            if (hamburgerDesktop) {
                if (hamburgerDesktopPlayer.play) {
                    hamburgerDesktopPlayer.reverse();
                }
            }

            tickerContainer?.classList.remove('sticky-ticker-desktop-dropdown-open');
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
        closeDesktopNav();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.addEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }

    // Throttle for resize listener to close open menus on page resize
    const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

    function resizeCloseNav() {
        let windowSize = window.innerWidth;
        const checkWidth = setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
            clearTimeout(checkWidth);
        }, 50);
    }


    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

    function clickOutsideCloseNav() {
        if (!document.getElementById('siteHeader').contains(event?.target)) {
            closeAllNavs();
            stopListening();
        }
    }


    // Throttle for scroll listener to close open menus if scroll exceeded scroll limit
    const closeNavScrollThrottle = _throttle(scrolledPastLimit, 50, {leading: true, trailing: true});

    function scrolledPastLimit() {
        if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit)) {
            closeAllNavs();
            stopListening();
        }
    }

    const clickListener = () => {
        closeNavClickDebounce(event);
    };

    const resizeListener = () => {
        closeNavResizeThrottle();
    };

    const scrollListener = () => {
        closeNavScrollThrottle();
    };

    // Throttle for scroll listener to adjust nav position based on scroll
    const throttleNavScrollCheck =  _throttle(navScrollCheck, 50, {leading: true, trailing: false});
    window.addEventListener('scroll', throttleNavScrollCheck, {passive: true});

    let scrollPositive = window.scrollY + scrollLimit;
    const delayedSet = setTimeout(() => {
        scrollPositive = window.scrollY + scrollLimit;
    }, 100);

    function navScrollCheck() {
        let scrollPos = window.scrollY;
        const checkScrollPos = setTimeout(() => {
            if (scrollPos > window.scrollY) {
                setNavStyles(true);
                scrollPositive = scrollPos + scrollLimit;
            } else if (scrollPos < window.scrollY) {
                if (scrollPositive < scrollPos) {
                    scrollPositive = scrollPos + scrollLimit;
                    setNavStyles(false);
                }
            }
            clearTimeout(checkScrollPos);
        }, 50);
    }

    // set nav position on load
    setNavStyles(true);

    const holderImage = document.querySelector('.holder-image-nav-top-adjust')

    // set nav pos / styles based on scrolling
    function setNavStyles(negScroll) {
        if (window.scrollY > scrollLimit && !negScroll) {
            siteHeader.dataset.visible = 'false';
            tickerContainer?.classList.add('sticky-ticker-nav-hidden');
            holderImage?.classList.add('md:!top-20');
        } else if (window.scrollY > scrollLimit && negScroll) {
            siteHeader.dataset.visible = 'true';
            tickerContainer?.classList.remove('sticky-ticker-nav-hidden');
            holderImage?.classList.remove('md:!top-20');
        } else {
            siteHeader.dataset.visible = 'true';
            tickerContainer?.classList.remove('sticky-ticker-nav-hidden');
            holderImage?.classList.remove('md:!top-20');
        }
    }

    // sticky ticker observer
    if (tickerContainer) {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('sticky-ticker', e.intersectionRatio < 1),
            {
                threshold: [1],
                'rootMargin': '-5px 0px 0px 0px'
            }
        );
        observer.observe(tickerContainer);
    }
});